<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">ตั้งค่าเว็บไซต์ </h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
          </div>
        </v-col>
      </v-row>

      <v-card elevation="4" style="border-radius: 15px;">
        <v-card-text>
          <div class="mt-3 pa-4">
            <v-form ref="form" @submit.prevent="updateEdit">
              <v-row>
                <!-- ข้อมูลทั่วไป -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/avatar_white.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลทั่วไป</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row style="padding-left: 50px;">
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ชื่อสาขา <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-storefront"
                      hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="input_set.store_name"
                      placeholder="กรุณากรอกชื่อสาขา" single-line outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="12" md="6" lg="5" xl="5" cols="12">
                  <label class="label_form_text">เบอร์โทร <span class="required--text">*</span></label>
                  <v-otp-input length="10" color="#D6BFAF" type="number" 
                    hide-details="auto" v-model="input_set.tel" outlined dense min="10"></v-otp-input>
                </v-col>

                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <label class="label_form_text">เลขที่เสียภาษี <span class="required--text">*</span></label>
                  <v-otp-input length="13" color="#D6BFAF" type="number" :rules="[v => (!!v  && v.length >= 13) || 'กรุณากรอกข้อมูล']"
                    v-model="input_set.store_personal_id" hide-details="auto" outlined dense></v-otp-input>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                  <label class="label_form_text">เลขที่สาขา <span class="required--text">*</span></label>
                  <v-otp-input length="5" color="#D6BFAF" type="number" :rules="[v => (!!v  && v.length >= 4) || 'กรุณากรอกข้อมูล']"
                    v-model="input_set.store_code" hide-details="auto" outlined dense></v-otp-input>
                </v-col>
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">รหัสใบกำกับภาษี</label>
                    <v-text-field
                      color="#D6BFAF"
                      class="input-radius"
                      prepend-inner-icon="mdi-file-document-outline"
                      hide-details="auto"
                      v-model="input_set.tax_invoice_code"
                      placeholder="กรุณากรอกรหัสใบกำกับภาษี"
                      single-line
                      outlined
                      dense
                    ></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="" lg="" xl="" cols="12">
                  <v-form-group>
                    <label class="label_form_text">POS ID <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" 
                      prepend-inner-icon="mdi-home" hide-details="auto" v-model="input_set.posid"
                      placeholder="กรุณากรอก POS ID" single-line outlined dense ></v-text-field>
                  </v-form-group>
                </v-col>


                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ที่อยู่ <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" :rules="[v => !!v || 'กรุณากรอกที่อยู่']"
                      prepend-inner-icon="mdi-home" hide-details="auto" v-model="input_set.address"
                      placeholder="กรุณากรอกที่อยู่" single-line outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ตำบล/อำเภอ/จังหวัด/รหัสไปรษณีย์ <span
                        class="required--text">*</span></label>
                    <v-autocomplete color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                      :items="addressList" item-text="name" item-value="name" v-model="input_set.address_list"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']" placeholder="ตำบล /อำเภอ /จังหวัด /รหัสไปรษณีย์ "
                      single-line outlined dense required>
                    </v-autocomplete>
                  </v-form-group>
                  {{ input_set.address_list && input_set.address_list !== 'null,null,null,null' ? input_set.address_list : '' }}
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">รหัสสีตรีมร้าน <span class="required--text">*</span></label>
                    <div class="mt-1 d-flex pa-2">
                      <v-input-colorpicker v-model="input_set.store_color" />
                      <div class="pl-3">{{ input_set.store_color }}</div>
                    </div>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <!-- VAT และเครดิตชาร์จ -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/bills_paper.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">VAT และเครดิตชาร์จ</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row style="padding-left: 50px;">
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">การคิด VAT <span class="required--text">*</span></label>
                    <v-radio-group v-model="input_set.vat" row :rules="[v => (v != null && v >= 0 || ``)]">
                      <v-radio label="ภาษีรวมใน" color="#D6BFAF" :value="0"></v-radio>
                      <v-radio label="ภาษีแยกนอก" color="#D6BFAF" :value="1"></v-radio>
                      <v-radio label="ไม่มีภาษี" color="#D6BFAF" :value="2"></v-radio>
                    </v-radio-group>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                  <v-form-group>
                    <label class="label_form_text">สถานะเครดิตชาร์จ</label>
                    <v-switch class="font-16" v-model="input_set.credit_charge_status" :label="`เปิดใช้เครดิตชาร์จ`"
                      color="success" inset @click="open_credit(input_set.credit_charge_status);"></v-switch>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row style="padding-left: 50px;">
                <v-col v-if="input_set.credit_charge_status == true" xs="12" sm="12" md="3" lg="3" xl="3" cols="12">
                  <v-form-group>
                    <label class="label_form_text">เปอร์เซ็นการหักเครดิตชาร์จ <span
                        class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-percent"
                      hide-details="auto" :rules="numberRules" v-model="input_set.credit_charge" maxlength="5"
                      @keypress="onlyForCurrency($event, input_set.credit_charge)" @paste="isPaste($event)"
                      placeholder="กรุณากรอกเปอร์เซ็นการหักเครดิตชาร์จ" single-line outlined dense
                      required></v-text-field>
                  </v-form-group>
                </v-col>
              </v-row>
              <v-row>
                <!-- ข้อมูลระบบ POS -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/cashier_white.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลระบบ POS</div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row style="padding-left: 50px;">
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <v-file-input id="fileUpload_logo_pos" accept="image/*" prepend-icon=""
                      @change="onFileChange_logo_pos" v-model="logo_pos_file" hide-input rules="" />
                    <label class="label_form_text">
                      รูปโลโก้หน้าระบบ POS (ขนาดไม่เกิน 500x500 พิกเซล) <span class="required--text">*</span></label>
                    <v-img v-if="input_set.logo_pos !== null" :lazy-src="input_set.logo_pos" :src="input_set.logo_pos"
                      style="max-width:250px;max-height:250px;height: 250px;" class="preview profile_img">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ" @click="getFile">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                    <v-img v-else :lazy-src="img_holder_cert" :src="img_holder_cert" class="preview profile_img"
                      style="max-width:250px;max-height:250px;height: 250px;">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ" @click="getFile">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-img>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <v-file-input id="fileUpload_logo_invoice" accept="image/*" prepend-icon=""
                      @change="onFileChange_logo_invioce" v-model="logo_invoice_file" hide-input />
                    <label class="label_form_text">
                      รูปโลโก้ในใบเสร็จ (ขนาดไม่เกิน 500x500 พิกเซล) <span class="required--text">*</span></label>
                    <v-img v-if="input_set.logo_invoice !== null" :lazy-src="input_set.logo_invoice"
                      style="max-width:250px;max-height:250px;height: 250px;" :src="input_set.logo_invoice"
                      class="preview profile_img">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ" @click="getFile_invioce">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img>
                    <v-img v-else :lazy-src="img_holder_cert" :src="img_holder_cert" class="preview profile_img"
                      style="max-width:250px;max-height:250px;height: 250px;">
                      <v-btn elevation="4" class="mt-2 btn_edit_logo" outlined color="#FEA06C"
                        title="อัพโหลดรูปภาพใบประกอบวิชาชีพ" @click="getFile_invioce">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn></v-img>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ขนาดใบเสร็จ <span class="required--text">*</span></label>
                    <v-radio-group v-model="input_set.receipt_size" row required :rules="[v => (v != null && v >= 0 || ``)]">
                      <v-radio label="58 มิลลิเมตร" color="#D6BFAF" :value="0"></v-radio>
                      <v-radio label="80 มิลลิเมตร" color="#D6BFAF" :value="1"></v-radio>
                    </v-radio-group>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                  <v-form-group>
                    <label class="label_form_text">รหัสเริ่มต้นเลขที่ใบเสร็จ <span class="required--text">*</span><span
                        class="grey--text">ไม่เกิน 6 ตัวอักษร</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-form-dropdown"
                      hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" maxlength="6"
                      v-model="input_set.invoice_start_code" placeholder="กรุณากรอกเลขที่ใบเสร็จ" single-line outlined
                      dense required></v-text-field>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ข้อความท้ายใบเสร็จ <span class="required--text">*</span> <span
                        class="grey--text">ไม่เกิน 150 ตัวอักษร</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-form-dropdown"
                      hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="input_set.invoice_note"
                      counter="150" placeholder="กรุณากรอกข้อความท้ายใบเสร็จ" single-line outlined dense
                      required></v-text-field>
                  </v-form-group>
                </v-col>

                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content:center;">
                    <v-btn type="submit" class="btn_add_data" elevation="4" large>บันทึก</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_profile.png";
import img_holder_document from "@/assets/arin_assets/image_document.png";
import img_holder_cert from "@/assets/arin_assets/image_sun_color.png";
import Swal from "sweetalert2";
import { HTTP_ARIN } from "@/axios_arin";
import { isTelephone, taxNumber, validateEmail, onPaste, onlyForCurrency } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Manage_website",
  data() {
    return {
      address: '',
      autocomplete: null,
      autocompleteItems: [],
      loading_page: false,
      img_holder: img_holder,
      img_holder_document: img_holder_document,
      img_holder_cert: img_holder_cert,
      logo_pos: null,
      logo_pos_file: null,
      logo_invoice: null,
      logo_invoice_file: null,
      otp_complete_tel: false,
      input_set: {
        address_list: ''
      },
      addressList: [],
      sub_menu: [
        {
          text: 'ตั้งค่าเว็บไซต์',
          disabled: false,
        }
      ],
    }
  },

  methods: {
    handleOnComplete(value) {
      this.otp_complete = true;
      this.input_set.tel = value;
    },
    handleOnChange(value) {
      this.otp_value = value;
    },
    // ฟังค์ชั่น การแสดงรายละเอียด
    async getShow_api() {
    
      let store_id = this.$store.state.store_arin.user_data.store_id;
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.input_set = res.data.storeDetail;
          this.input_set.tax_invoice_code = this.input_set.tax_invoice_code != null ? this.input_set.tax_invoice_code : '';
          this.input_set.address_list = ''
          if (res.data.storeDetail.sub_district != '' && res.data.storeDetail.district != '' && res.data.storeDetail.province != '' && res.data.storeDetail.postcode != '') {
              this.input_set.address_list = res.data.storeDetail.sub_district + ',' + res.data.storeDetail.district + ',' + res.data.storeDetail.province + ',' + res.data.storeDetail.postcode
          }

        }
      })
    },



    getAddress_api() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/stores/addresslist', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.addressList = res.data.addressList;
        }
      })
    },

    async checkLogIn() {
      if (this.$store.state.store_arin.access_token === null) {
        this.$store.commit('store_arin/logout_success');
        this.$router.push('/arin/login');
      }
    },

    // ฟังค์ชั่น การนำไป save
    updateEdit() {
      console.log(this.input_set);
      let credit_charge_status = null;
      if (this.input_set.credit_charge_status == true) {
        credit_charge_status = 1;
      } else {
        credit_charge_status = 0;
      }
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      let store_id = this.$store.state.store_arin.user_data.store_id;
      if (this.input_set.address_list == 'null,null,null,null') {
        this.input_set.address_list = ''
      }
      else if (this.input_set.invoice_note.length > 150) {
        Swal.fire({
          title: 'แจ้งเตือน',
          text: 'ข้อความท้ายใบเสร็จ ต้องไม่เกิน 150 ตัวอักษร',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      } else if (this.input_set.logo_pos == null) {
        Swal.fire({
          title: 'แจ้งเตือน',
          text: 'กรุณากรอกเลือกโลโก้หน้าระบบ POS',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      } else if (this.input_set.logo_invoice == null) {
        Swal.fire({
          title: 'แจ้งเตือน',
          text: 'กรุณากรอกเลือกโลโก้ใบเสร็จระบบ POS',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      // } else if (this.input_set.tel.length != 10) {
      //   Swal.fire({
      //     title: 'แจ้งเตือน',
      //     text: 'กรุณากรอกหมายเลขโทรศัพท์ให้ครบ 10 หลัก',
      //     icon: 'warning',
      //     showDenyButton: false,
      //     showCancelButton: false,
      //     confirmButtonText: `ตกลง`,
      //     denyButtonText: `ยกเลิก`,
      //   });
      } else if (this.input_set.store_personal_id.length != 13) {
        Swal.fire({
          title: 'แจ้งเตือน',
          text: 'กรุณากรอกหมายเลขที่เสียภาษีให้ครบ 13 หลัก',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      } else if (this.input_set.receipt_size == null) {
        Swal.fire({
          title: 'แจ้งเตือน',
          text: 'กรุณาเลือกขนาดใบเสร็จ',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        });
      } else {
        if (this.$refs.form.validate()) {
          let formData = new FormData();
          formData.append('id', store_id)
          formData.append('store_name', this.input_set.store_name)
          formData.append('tel', this.input_set.tel);
          formData.append('store_personal_id', this.input_set.store_personal_id);
          formData.append('address', this.input_set.address);
          formData.append('store_code', this.input_set.store_code);
          formData.append('sub_address', this.input_set.address_list);
          formData.append('store_color', this.input_set.store_color);
          formData.append('vat', this.input_set.vat);
          formData.append('credit_charge_status', credit_charge_status);
          formData.append('credit_charge', this.input_set.credit_charge);
          formData.append('receipt_size', this.input_set.receipt_size);
          formData.append('invoice_start_code', this.input_set.invoice_start_code);
          formData.append('invoice_note', this.input_set.invoice_note);
          formData.append('logo_pos', this.logo_pos_file);
          formData.append('logo_invoice', this.logo_invoice_file);
          formData.append('user_update', this.input_set.user_update);
          formData.append('posid', this.input_set.posid);
          formData.append('tax_invoice_code', this.input_set.tax_invoice_code != null ? this.input_set.tax_invoice_code : '');

          HTTP_ARIN.post('/stores/seting/' + store_id, formData, config)
            .then((res) => {
              if (res.data.successful === true) {
                let timerInterval
                Swal.fire({
                  title: 'เสร็จสิ้น',
                  text: 'แก้ไขข้อมูลเรียบร้อย',
                  icon: 'success',
                  timer: 2000,
                  timerProgressBar: true,
                  didOpen: () => {
                    Swal.showLoading()
                    timerInterval = setInterval(() => { }, 100)
                  },
                  willClose: () => {
                    clearInterval(timerInterval)
                    setTimeout(function () {
                      window.location.reload();
                    });
                  }
                })
              }
              else {
                Swal.fire({
                  title: 'แจ้งเตือน',
                  text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                  icon: 'error',
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: `ตกลง`,
                  denyButtonText: `ยกเลิก`,
                })
              }
            })
        }
      }
    },

    // ฟังค์ชั่น การกด input file
    getFile() {
      let fileUpload = document.getElementById('fileUpload_logo_pos')
      if (fileUpload != null) {
        fileUpload.click()
      }
    },

    // ฟังค์ชั่น การกด input file
    getFile_invioce() {
      let fileUpload = document.getElementById('fileUpload_logo_invoice')
      if (fileUpload != null) {
        fileUpload.click()
      }
    },

    // ฟังค์ชั่น การดักนามสกุลไฟล์ และ preview image
    onFileChange_logo_pos(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.input_set.logo_pos = null
          })
        } else {
          if (file) {
            this.input_set.logo_pos = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
            // console.log(URL);
          } else {
            this.input_set.logo_pos = null
          }
        }
      } 
      //else {
         //this.input_set.logo_pos = null
      //}
    },

    // ฟังค์ชั่น การดักนามสกุลไฟล์ และ preview image
    onFileChange_logo_invioce(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.input_set.logo_invoice = null
          })
        } else {
          if (file) {
            this.input_set.logo_invoice = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.input_set.logo_invoice = null
          }
        }
      } 
      //else {
        //this.input_set.logo_invoice = null
      //}
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
  },
  computed: {
    numberRules() {
      return [
        value => value >= 0 && value <= 100 || 'การหักเครดิตชาร์จสูงสุด 100%',
        value => !!value || 'กรุณากรอกข้อมูล',
      ]
    },
    activeItem() {
      // return the selected item object if it exists in the items array
      return this.items.find(item => item.name === this.input_set.address_list);
    },
  },
  watch:{
    "input_set.invoice_start_code" :async function(val){
      this.input_set.invoice_start_code =await val.replace(/-/g, '');
      }
    },
  mounted() {
    this.checkLogIn()
    this.getShow_api()
    this.getAddress_api()
  }

}
</script>

<style scoped>
.space-tel {
  display: flex;
  align-items: center;
  margin: 0 3px;
  font-size: 18px;
  color: #909090;
}

.my-text-field>>>input {
  height: 40px;
}

.tel-center>>>input {
  text-align: center;
}

.grey--text {
  color: #909090 !important;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

.header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
}

.v-tab {
  font-size: 16px;
  font-weight: 500;
}

.v-tab.v-tab--active {
  font-size: 16px;
  font-weight: 700;
}

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.title_form_header {
  background: #D6BFAF;
  padding: 4px 10px 4px 10px;
  /* opacity: 0.35; */
  border: 1px solid #D6BFAF;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 0px 30px 30px 0px;

}

.title_form_header_text {
  color: #616A6B;
}


.logo_timeline {
  padding: 6px;
}


.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}



.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-around;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: 55px;
  left: 150px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 300px;
  border-radius: 30px;
}

.btn_edit_logo {
  border-radius: 10px;
  background-color: #FFF;
  position: absolute;
  top: 8px;
  right: 16px;
}


.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.table-data-img-center {
  display: flex;
  justify-content: center;
}

.flex-item-center {
  display: flex;
  align-items: center;
}

.v-data-table__wrapper>>>span {
  font-size: 50px;
}

.title_form {
  display: flex;
  margin-top: 2px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616A6B !important;
}

.font-16 {
  font-size: 14px !important;
  color: #616A6B !important;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }

  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 50%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 30%;
  }
}
</style>
